import { useState } from "react";
import { useLang } from "@/contexts/LangContext";
import SectionReveal from "@/components/SectionReveal";
import { Plane, CreditCard, Train, Languages, Wifi, HandHeart, ChevronDown } from "lucide-react";

const ICONS = [Plane, CreditCard, Train, Languages, Wifi, HandHeart];

const TravelTips = () => {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="tips" data-testid="tips-section" className="bg-[#F7F5F0] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionReveal className="max-w-3xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C62828] font-semibold mb-4">
            ✦ {t.tips.eyebrow}
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#121212] leading-[1.05]">
            {t.tips.title}
          </h2>
        </SectionReveal>

        {/* Mobile: accordion (compact). Desktop: card grid */}
        <div data-testid="tips-accordion-mobile" className="mt-12 md:hidden border-t border-black/10">
          {t.tips.items.map((tip, i) => {
            const Icon = ICONS[i];
            const open = openIdx === i;
            return (
              <div key={tip.title} className="border-b border-black/10">
                <button
                  data-testid={`tip-accordion-toggle-${i}`}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-3 py-5 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span className="w-9 h-9 flex items-center justify-center bg-[#C62828]/10 text-[#C62828]">
                      <Icon size={17} strokeWidth={1.5} />
                    </span>
                    <span className="font-heading text-lg text-[#121212]">{tip.title}</span>
                  </span>
                  <ChevronDown
                    size={18}
                    className={`text-[#4A4A4A] transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {open && (
                  <p
                    data-testid={`tip-accordion-body-${i}`}
                    className="pb-5 pr-2 text-[#4A4A4A] leading-relaxed"
                  >
                    {tip.body}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-16 hidden md:grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {t.tips.items.map((tip, i) => {
            const Icon = ICONS[i];
            return (
              <SectionReveal
                key={tip.title}
                delay={i * 0.08}
                data-testid={`tip-card-${i}`}
                className="group bg-white border border-[#EAE6DF] p-8 hover:border-[#C62828]/40 hover:-translate-y-1 transition-all duration-500"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#C62828]/10 text-[#C62828] group-hover:bg-[#C62828] group-hover:text-white transition-colors duration-500">
                  <Icon size={22} strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-heading text-2xl text-[#121212]">{tip.title}</h3>
                <p className="mt-3 text-[#4A4A4A] leading-relaxed">{tip.body}</p>
              </SectionReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TravelTips;
